import { useState, createContext, useContext } from 'react'
import { LoyaltyCardType } from 'components/Loyalty/types'

export type LoyaltyCardsState = {
  loyaltyCards: LoyaltyCardType[]
  setLoyaltyCards: (cards: LoyaltyCardType[]) => void
  hasLoyaltyCards: boolean
  setHasLoyaltyCards: (value: boolean) => void
  loading: boolean
  setLoading: (value: boolean) => void
}

export const SetupLoyaltyCards = (): LoyaltyCardsState => {
  const [loyaltyCards, setLoyaltyCards] = useState<LoyaltyCardType[]>([])
  const [hasLoyaltyCards, setHasLoyaltyCards] = useState(false)
  const [loading, setLoading] = useState(false)

  return {
    loyaltyCards,
    setLoyaltyCards,
    hasLoyaltyCards,
    setHasLoyaltyCards,
    loading,
    setLoading
  }
}

const initialState: LoyaltyCardsState = {
  loyaltyCards: [],
  setLoyaltyCards: () => null,
  hasLoyaltyCards: false,
  setHasLoyaltyCards: () => null,
  loading: false,
  setLoading: () => null
}

export const LoyaltyCardsContext =
  createContext<LoyaltyCardsState>(initialState)

export const useLoyaltyCards = () => useContext(LoyaltyCardsContext)
